import { type Ref } from "vue";
import { useThreadStore } from "@/stores/thread.store";
import type { Message as ApiMessage, MessageThread } from "@/api/javaapi";

export function useMessageHandler(threadRef: Ref<MessageThread | null | undefined>, sendMessageFormRef: any) {
  const threadStore = useThreadStore();

  const updateMessageList = (message: ApiMessage, isNew: boolean) => {
    const thread = threadRef.value;
    console.log("updateMessageList", message, isNew, thread);
    if (!thread) return;

    const updatedMessages = [...(thread.messages ?? [])];
    const index = updatedMessages.findIndex((m) => m.id === message.id);
    if (index !== -1) {
      updatedMessages[index] = message;
    } else if (isNew) {
      updatedMessages.push(message);
    }

    const updatedThread = { ...thread, messages: updatedMessages };
    threadStore.updateThreadInList(updatedThread);
  };

  const handleNewMessage = (tempMessage: ApiMessage) => {
    updateMessageList(tempMessage, true);
  };

  const handleMessageSuccess = (data: { tempId: number; message: ApiMessage }) => {
    const thread = threadRef.value;
    if (!thread) return;

    const updatedMessages = thread.messages?.map((m) =>
      m.id === data.tempId ? { ...data.message } : m
    ) ?? [];

    const updatedThread = { ...thread, messages: updatedMessages };
    threadStore.updateThreadInList(updatedThread);
  };

  const handleMessageFailed = (failedMessage: ApiMessage) => {
    updateMessageList(failedMessage, false);
  };

  const handleUpdateMessage = (updatedMessage: ApiMessage) => {
    updateMessageList(updatedMessage, false);
  };

  const handleRetryMessage = (message: ApiMessage) => {
    if (sendMessageFormRef.value) {
      sendMessageFormRef.value.retryMessage(message);
    } else {
      console.error("SendMessageForm ref is not available");
    }
  };

  return {
    handleNewMessage,
    handleMessageSuccess,
    handleMessageFailed,
    handleUpdateMessage,
    handleRetryMessage,
  };
}